// extracted by mini-css-extract-plugin
export var heroOverlay = "CalligraphicOpeningHero-module--hero-overlay--74441";
export var overlayFooter = "CalligraphicOpeningHero-module--overlay-footer--6f3fa";